import { HttpStatusCode, isAxiosError } from 'axios';

import { logger } from '@dist-marketplace-frontend/services';
import { fireToast } from '../../../../helpers/Toasts';

import type { FinanceValidationError } from '../schema/carFinance.schema';
import { financeValidationErrorSchema } from '../schema/carFinance.schema';
import { PAGE } from '../../../../helpers/pages';

export const handleFinanceValidationError = (
  error: Error,
  onValidationError: (error: FinanceValidationError) => void,
  logMessage: string,
) => {
  if (
    !isAxiosError(error) ||
    error.response?.status !== HttpStatusCode.UnprocessableEntity
  ) {
    // Non-422 errors are handled by the global MutationCache.onError
    // (toast + raygun log). No further handling needed here.
    return;
  }
  const { data } = error.response;
  const parsedError = financeValidationErrorSchema.safeParse(data);
  if (parsedError.success) {
    onValidationError(parsedError.data);
  } else {
    // The 422 body doesn't match our schema. The global handler skips
    // 422s entirely, so we must show feedback manually.
    fireToast({
      text: 'Something went wrong. Please try again.',
      type: 'ERROR',
    });
    logger.error({
      error,
      message: logMessage,
      tags: [PAGE.CAR_FINANCE],
    });
  }
};
